/**
 * Message types pushed over the live feed, ported from `Enums.MessageTypes`. The
 * feed handler switches on these, so the numbers are contractual.
 */
export const LiveMessageType = {
  LiveUpdate: 1,
  LiveUpdateNewEvent: 2,
  LiveStatistics: 10,
  LiveUpdateFinish: 100,
  Result: 200,
  LiveBlock: 500,
  LiveBlockSuspended: 501,
  LiveBlockAll: 510,
  Block: 520,
  LiveRollback: 550,
  PreUpdate: 1000,
} as const;

export type LiveMessageType = (typeof LiveMessageType)[keyof typeof LiveMessageType];

/** Messages that suspend or unblock prices rather than carrying new ones. */
export const LIVE_BLOCK_MESSAGE_TYPES: readonly LiveMessageType[] = [
  LiveMessageType.LiveBlock,
  LiveMessageType.LiveBlockSuspended,
  LiveMessageType.LiveBlockAll,
  LiveMessageType.Block,
];

export function isBlockMessage(type: number): boolean {
  return LIVE_BLOCK_MESSAGE_TYPES.includes(type as LiveMessageType);
}

/** Which feed provider the brand is on; changes how event payloads are shaped. */
export const FeedType = {
  Standard: 0,
  UOF: 1,
  LSports: 2,
} as const;

export type FeedType = (typeof FeedType)[keyof typeof FeedType];

export const LiveViewType = {
  Overview: 0,
  EventView: 1,
} as const;

export type LiveViewType = (typeof LiveViewType)[keyof typeof LiveViewType];

/** Live match tracker widget provider, from `Enums.LMTWidgetTypes`. */
export const LmtWidgetType = {
  None: 0,
  Betradar: 1,
  TheSports: 2,
} as const;

export type LmtWidgetType = (typeof LmtWidgetType)[keyof typeof LmtWidgetType];
